export const BILLING_DATA_TEXT = Object.freeze({
  common: {
    close: 'Cerrar',
    defaultBadge: 'Principal',
  },
  list: {
    title: 'Datos de facturación',
    subtitle: 'Consulta, edita o elimina los datos de facturación de la entidad.',
    empty: 'Sin datos de facturación registrados.',
    actions: {
      edit: 'Editar dato de facturación',
      delete: 'Eliminar dato de facturación',
    },
  },
  card: {
    title: 'Datos de facturación',
    residenceLabel: 'Residencia fiscal',
    actions: {
      openList: 'Ver listado de datos de facturación',
      create: 'Agregar nuevo dato de facturación',
      edit: 'Editar datos de facturación',
    },
  },
  modal: {
    titleCreate: 'Nuevo dato de facturación',
    titleEdit: 'Editar datos de facturación',
    subtitleCreate: 'Captura identificación fiscal, dirección y datos bancarios.',
    subtitleEdit: 'Actualiza identificación fiscal, dirección y datos bancarios.',
    closeAriaLabel: 'Cerrar modal',
    sectionsAriaLabel: 'Secciones del formulario de facturación',
    submitCreate: 'Guardar',
    submitEdit: 'Guardar cambios',
    cancel: 'Cancelar',
    sections: {
      fiscalIdent: {
        title: 'Identificación fiscal',
        description: 'Tipo, RFC/identificador y razón social.',
      },
      fiscalConfig: {
        title: 'Configuración fiscal',
        description: 'Régimen, uso CFDI y políticas de pago.',
      },
      fiscalAddress: {
        title: 'Dirección fiscal',
        description: 'Estado, calle, números y colonia.',
      },
      bankData: {
        title: 'Datos bancarios',
        description: 'Cuenta de pago y banco ordenante.',
      },
    },
    contributorTypes: {
      national: 'Nacional',
      foreign: 'Extranjero',
    },
    taxIdentifierLabels: {
      national: 'RFC',
      foreign: 'Identificador',
    },
    form: {
      fiscalIdentification: {
        title: 'Identificación fiscal',
        subtitle: 'Datos principales para emitir CFDI al cliente.',
        fields: {
          contributorType: 'Tipo de contribuyente',
          fiscalName: 'Razón social',
          fiscalZipCode: 'Dirección fiscal (C.P.)',
          defaultFiscalData: 'Usar esta identificación fiscal como predeterminada para facturación.',
        },
        placeholders: {
          contributorType: 'Selecciona tipo',
          taxIdentifier: 'Captura RFC o identificador',
          fiscalName: 'Captura razón social',
          fiscalZipCode: 'Captura código postal',
        },
      },
      fiscalConfiguration: {
        title: 'Configuración fiscal',
        subtitle: 'Parámetros fiscales por defecto para facturación.',
        fields: {
          fiscalRegime: 'Régimen fiscal',
          cfdiUse: 'Uso de CFDI',
          paymentMethod: 'Forma de pago',
          paymentMethodType: 'Método de pago',
        },
        placeholders: {
          fiscalRegime: 'Selecciona régimen',
          cfdiUse: 'Selecciona uso de CFDI',
          paymentMethod: 'Selecciona forma de pago',
          paymentMethodType: 'Selecciona método de pago',
        },
      },
      fiscalAddress: {
        title: 'Dirección fiscal',
        subtitle: 'Dirección asociada al contribuyente para uso fiscal.',
        fields: {
          skipFiscalAddress: 'No registrar dirección fiscal',
          state: 'Estado',
          municipality: 'Municipio',
          street: 'Calle',
          exterior: 'No exterior',
          interior: 'No interior',
          neighborhood: 'Colonia',
        },
        placeholders: {
          state: 'Selecciona estado',
          municipality: 'Captura municipio',
          street: 'Captura calle',
          exterior: 'No. exterior',
          interior: 'No. interior (opcional)',
          neighborhood: 'Captura colonia',
        },
      },
      bankData: {
        title: 'Datos bancarios',
        subtitle: 'Datos para complementar información de pago.',
        fields: {
          paymentAccount: 'Número de cuenta beneficiario',
          beneficiaryBankRfc: 'RFC del banco beneficiario',
          paymentComplement: 'Complemento de pago',
          orderingBank: 'Banco Ordenante',
          orderingBankRfc: 'RFC del banco Ordenante',
          orderingBankAccount: 'Número de cuenta Ordenante',
        },
        placeholders: {
          paymentAccount: 'Captura número de cuenta beneficiario',
          beneficiaryBankRfc: 'Captura RFC del banco beneficiario',
          orderingBank: 'Captura banco ordenante',
          orderingBankRfc: 'Captura RFC del banco',
          orderingBankAccount: 'Captura cuenta ordenante',
        },
      },
    },
    validation: {
      fiscalNameRequired: 'La razón social es obligatoria.',
      zipCodeRequired: 'La dirección fiscal (C.P.) es obligatoria.',
      rfcRequiredNational: 'El RFC es obligatorio para contribuyente nacional.',
      fiscalRegimeRequired: 'El régimen fiscal es obligatorio.',
      cfdiUseRequired: 'El uso de CFDI es obligatorio.',
      paymentMethodRequiredNational: 'La forma de pago es obligatoria para contribuyente nacional.',
      paymentMethodTypeRequiredNational: 'El método de pago es obligatorio para contribuyente nacional.',
    },
  },
  confirm: {
    titleDelete: 'Eliminar dato de facturación',
    subtitle: 'Confirma para continuar con esta operación.',
    messageDelete: ({ rfc, fiscalName }) => `RFC: ${rfc}, Razón social: ${fiscalName}. Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?`,
    confirmButton: 'Eliminar',
    fallbackRfc: '-',
    fallbackFiscalName: '-',
  },
  toast: {
    deleteSuccess: 'Dato de facturación eliminado correctamente.',
    deleteError: 'No fue posible eliminar el dato de facturación.',
    createSuccess: 'Dato de facturación registrado correctamente.',
    updateSuccess: 'Dato de facturación actualizado correctamente.',
    saveError: 'No fue posible guardar los datos de facturación.',
  },
});